<template>
  <div class="panel-view" :class="{ 'panel-open': $slots.panel }">
    <section class="page">
      <slot />
    </section>

    <section
      v-if="$slots.panel"
      id="side-panel"
      class="panel"
    >
      <slot name="panel" />
    </section>
  </div>
</template>

<script>
export default {
  watch: {
    showPanel: {
      handler(value) {
        if (value) {
          document.body.classList.add('disable-mobile-scroll');
        } else {
          document.body.classList.remove('disable-mobile-scroll');
        }
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.panel-view {
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 1fr auto;
}

.page {
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.panel {
  @include overflowY;
  width: 560px;
  position: sticky;
  top: var(--header-height);
  right: 0;
  height: calc(100vh - var(--header-height));
  background-color: var(--theme-background);
  border-left: 1px solid var(--theme-border);
  z-index: 2;

  @media($medium-down) {
    width: 100vw;
    border-left: none;
  }
}
</style>
